<template lang="pug">

    .ui.horizontal.basic.segments

        .ui.basic.segment
            //- Produkt-ID
            h5.ui.header
                | Produkt-ID
                .sub.header {{ product.zmuekId }}

            //- Status
            h5.ui.header
                | Produktstatus
                .sub.header
                    status-dropdown(v-bind:productModel='product' v-bind:priceModels='priceModels' v-bind:jobModels='jobModels')

        //- Produkttyp & Druckdatenstatus
        .ui.basic.segment
            h5.ui.header
                | Typ
                .sub.header {{ type.name }}
            h5.ui.header
                | Druckdatenstatus
                .sub.header {{ printingDataStatus }}

        //- Kunde und Liefertermn
        .ui.basic.segment
            h5.ui.header
                | Kunde
                .sub.header
                    router-link(
                        v-if='$auth.isZmuekish'
                        v-bind:to='{ name: "companies/update", params: { id: company.id }}'
                    ) {{ company.name }}
                    span(v-else) {{ company.name }}
            h5.ui.header
                | Liefertermin
                .sub.header
                    span {{ deliveryDate }}

        //- Kampagne & Medienproduktioner
        .ui.basic.segment

            //- Kampagne
            h5.ui.header
                | Kampagne
                .sub.header
                    router-link(:to='{ name: "campaigns/update", params: { id: campaign.id }}' v-if="campaign.id") {{ campaign.name }}
                    span(v-else) -

            //- Medienproduktioner
            h5.ui.header
                | Medienproduktioner
                .sub.header
                    router-link(
                        v-if='$auth.isZmuekish'
                        v-bind:to='{ name: "users/update", params: { id: product.mediaProduction }}'
                    ) {{ mediaProductionPerson.firstName }} {{ mediaProductionPerson.lastName }}
                    span(v-else) {{ mediaProductionPerson.firstName }} {{ mediaProductionPerson.lastName }}

</template>

<script>
    import { string_to_readable as date_string_to_readable }  from '@/utils/date'
    import StatusDropdown from './StatusDropdown.vue'

    export default {

        components: {
            StatusDropdown
        },

        computed: {

            deliveryDate() {
                return date_string_to_readable(this.product.deliveryDate)
            },

            mediaProduction() {
                const user = this.$store.getters['users/byId'](this.product.mediaProduction)
                const person = this.$store.getters['persons/byId'](user.person)
                return {...user, person}
            },

            printingDataStatus() {
                switch (this.product.printingDataStatus) {
                    case 'WAITING_FOR_DATA': return 'Warten auf Daten'
                    case 'IN_REVIEW': return 'Erst-/Zweitprüfung'
                    case 'WAITING_FOR_FORM_PROOF': return 'Warten auf Freigabe-PDF'
                    case 'FORM_PROOF_CONFIRMED': return 'Freigabe-PDF bestätigt'
                    case 'COMPLETED': return 'Abgeschlossen'
                    default: return `Unbekannter Status: ${this.product.printingDataStatus}`
                }
            }

        },

        props: {

            campaign: {
                type: Object,
                required: true
            },

            company: {
                type: Object,
                required: true
            },

            mediaProductionPerson: {
                type: Object,
                required: true
            },

            jobModels: {
                type: Array,
                default: () => []
            },

            priceModels: {
                type: Array,
                default: () => []
            },

            product: {
                type: Object,
                required: true
            },

            type: {
                type: Object,
                required: true
            },
        }

    }

</script>

<style scoped>
    .ui.basic.segments {
       margin: 0; 
    }
</style>
